// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { CommonAiSuggestionFragment } from './aiSuggestions.generated';
import { gql } from '@apollo/client';
import { CommonAiSuggestionFragmentDoc } from './aiSuggestions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchTestamentaryEntityAiSuggestionsV2QueryVariables = Types.Exact<{
  testamentaryEntityID: Types.Scalars['ID']['input'];
}>;


export type FetchTestamentaryEntityAiSuggestionsV2Query = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & CommonAiSuggestionFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    FetchTestamentaryEntityAISuggestionsV2: 'FetchTestamentaryEntityAISuggestionsV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const FetchTestamentaryEntityAiSuggestionsV2Document = gql`
    query FetchTestamentaryEntityAISuggestionsV2($testamentaryEntityID: ID!) {
  aiSuggestions(
    where: {kindIn: [SUBTRUST_LIFETIME_BENEFICIARY, SUBTRUST_REMAINDER_BENEFICIARY, SUBTRUST_TRUSTEE, SUBTRUST_SUCCESSOR_TRUSTEE, SUBTRUST_TRUST_ADVISOR, SUBTRUST_CREATED_FROM, SUBTRUST_GST_STATUS], or: [{acceptanceStatusIsNil: true}, {acceptanceStatus: ACCEPTED}, {acceptanceStatus: AUTO_ACCEPTED}], hasTestamentaryEntityWith: {id: $testamentaryEntityID}}
    orderBy: {field: created_at, direction: DESC}
  ) {
    edges {
      node {
        ...CommonAISuggestion
      }
    }
  }
}
    ${CommonAiSuggestionFragmentDoc}`;

/**
 * __useFetchTestamentaryEntityAiSuggestionsV2Query__
 *
 * To run a query within a React component, call `useFetchTestamentaryEntityAiSuggestionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchTestamentaryEntityAiSuggestionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTestamentaryEntityAiSuggestionsV2Query({
 *   variables: {
 *      testamentaryEntityID: // value for 'testamentaryEntityID'
 *   },
 * });
 */
export function useFetchTestamentaryEntityAiSuggestionsV2Query(baseOptions: Apollo.QueryHookOptions<FetchTestamentaryEntityAiSuggestionsV2Query, FetchTestamentaryEntityAiSuggestionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTestamentaryEntityAiSuggestionsV2Query, FetchTestamentaryEntityAiSuggestionsV2QueryVariables>(FetchTestamentaryEntityAiSuggestionsV2Document, withFetchPolicyContext(options));
      }
export function useFetchTestamentaryEntityAiSuggestionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTestamentaryEntityAiSuggestionsV2Query, FetchTestamentaryEntityAiSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTestamentaryEntityAiSuggestionsV2Query, FetchTestamentaryEntityAiSuggestionsV2QueryVariables>(FetchTestamentaryEntityAiSuggestionsV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchTestamentaryEntityAiSuggestionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchTestamentaryEntityAiSuggestionsV2Query, FetchTestamentaryEntityAiSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTestamentaryEntityAiSuggestionsV2Query, FetchTestamentaryEntityAiSuggestionsV2QueryVariables>(FetchTestamentaryEntityAiSuggestionsV2Document, withFetchPolicyContext(options));
        }
export type FetchTestamentaryEntityAiSuggestionsV2QueryHookResult = ReturnType<typeof useFetchTestamentaryEntityAiSuggestionsV2Query>;
export type FetchTestamentaryEntityAiSuggestionsV2LazyQueryHookResult = ReturnType<typeof useFetchTestamentaryEntityAiSuggestionsV2LazyQuery>;
export type FetchTestamentaryEntityAiSuggestionsV2SuspenseQueryHookResult = ReturnType<typeof useFetchTestamentaryEntityAiSuggestionsV2SuspenseQuery>;
export type FetchTestamentaryEntityAiSuggestionsV2QueryResult = Apollo.QueryResult<FetchTestamentaryEntityAiSuggestionsV2Query, FetchTestamentaryEntityAiSuggestionsV2QueryVariables>;